"use client";

import { c as _c } from "react/compiler-runtime";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ActiveDropState } from "@/types/dropInteractionTypes";
import { DropInteractionParams, DropLocation } from "../Drop";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { useState, useCallback } from "react";
import Link from "next/link";
import { useRouter } from "next/navigation";
import useIsMobileDevice from "@/hooks/isMobileDevice";
import WaveDropActions from "../WaveDropActions";
import WaveDropMobileMenu from "../WaveDropMobileMenu";
import WaveDropContent from "../WaveDropContent";
import WaveDropMetadata from "../WaveDropMetadata";
import WaveDropAuthorPfp from "../WaveDropAuthorPfp";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { getTimeAgoShort } from "@/helpers/Helpers";
import { getWaveRoute } from "@/helpers/navigation.helpers";
import WaveDropReactions from "../WaveDropReactions";
interface EndedParticipationDropProps {
  readonly drop: ExtendedDrop;
  readonly showWaveInfo: boolean;
  readonly activeDrop: ActiveDropState | null;
  readonly showReplyAndQuote: boolean;
  readonly location: DropLocation;
  readonly onReply: (param: DropInteractionParams) => void;
  readonly onQuote: (param: DropInteractionParams) => void;
  readonly onQuoteClick: (drop: ApiDrop) => void;
  readonly onDropContentClick?: ((drop: ExtendedDrop) => void) | undefined;
}
export default function EndedParticipationDrop(t0) {
  const $ = _c(81);
  const {
    drop,
    showWaveInfo,
    activeDrop,
    showReplyAndQuote,
    location,
    onReply,
    onQuote,
    onQuoteClick,
    onDropContentClick
  } = t0;
  const isActiveDrop = activeDrop?.drop.id === drop.id;
  const router = useRouter();
  const [activePartIndex, setActivePartIndex] = useState(0);
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [isSlideUp, setIsSlideUp] = useState(false);
  const isMobile = useIsMobileDevice();
  let t1;
  if ($[0] !== router) {
    t1 = (e, path) => {
      e.preventDefault();
      e.stopPropagation();
      router.push(path);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleNavigation = t1;
  let t2;
  if ($[2] !== isMobile) {
    t2 = () => {
      if (!isMobile) {
        return;
      }
      setLongPressTriggered(true);
      setIsSlideUp(true);
    };
    $[2] = isMobile;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleLongPress = t2;
  let t3;
  if ($[4] !== activePartIndex || $[5] !== drop || $[6] !== onReply) {
    t3 = () => {
      setIsSlideUp(false);
      onReply({
        drop,
        partId: drop.parts[activePartIndex]?.part_id
      });
    };
    $[4] = activePartIndex;
    $[5] = drop;
    $[6] = onReply;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleOnReply = t3;
  let t4;
  if ($[8] !== activePartIndex || $[9] !== drop || $[10] !== onQuote) {
    t4 = () => {
      setIsSlideUp(false);
      onQuote({
        drop,
        partId: drop.parts[activePartIndex]?.part_id
      });
    };
    $[8] = activePartIndex;
    $[9] = drop;
    $[10] = onQuote;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleOnQuote = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      setIsSlideUp(false);
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleOnAddReaction = t5;
  const t6 = `${location === DropLocation.WAVE ? "tw-px-4 tw-py-1" : ""} tw-w-full`;
  const t7 = `tw-relative tw-w-full tw-flex tw-flex-col tw-px-4 tw-py-3 tw-rounded-lg tw-overflow-hidden tw-group tw-transition-colors tw-duration-200 tw-ease-linear
          ${isActiveDrop ? "tw-bg-[#3CCB7F]/10" : location === DropLocation.WAVE ? "tw-bg-iron-900/60 tw-ring-1 tw-ring-inset tw-ring-iron-800" : "tw-bg-iron-950 tw-ring-1 tw-ring-inset tw-ring-iron-800"}`;
  let t8;
  if ($[13] !== activePartIndex || $[14] !== drop || $[15] !== handleOnQuote || $[16] !== handleOnReply || $[17] !== isMobile || $[18] !== showReplyAndQuote) {
    t8 = !isMobile && showReplyAndQuote && <WaveDropActions drop={drop} activePartIndex={activePartIndex} showVoting={false} onReply={handleOnReply} onQuote={handleOnQuote} />;
    $[13] = activePartIndex;
    $[14] = drop;
    $[15] = handleOnQuote;
    $[16] = handleOnReply;
    $[17] = isMobile;
    $[18] = showReplyAndQuote;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== drop) {
    t9 = <WaveDropAuthorPfp drop={drop} />;
    $[20] = drop;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] !== drop.author.level) {
    t10 = <UserCICAndLevel level={drop.author.level} size={UserCICAndLevelSize.SMALL} />;
    $[22] = drop.author.level;
    $[23] = t10;
  } else {
    t10 = $[23];
  }
  let t11;
  if ($[24] !== drop.author.handle || $[25] !== handleNavigation) {
    t11 = e_0 => handleNavigation(e_0, `/${drop.author.handle}`);
    $[24] = drop.author.handle;
    $[25] = handleNavigation;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const t12 = `/${drop.author.handle}`;
  let t13;
  if ($[27] !== drop.author.handle || $[28] !== t11 || $[29] !== t12) {
    t13 = <p className="tw-text-md tw-mb-0 tw-leading-none tw-font-semibold"><Link onClick={t11} href={t12} className="tw-no-underline tw-text-iron-200 hover:tw-text-iron-500 tw-transition tw-duration-300 tw-ease-out">{drop.author.handle}</Link></p>;
    $[27] = drop.author.handle;
    $[28] = t11;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="tw-size-[3px] tw-bg-iron-600 tw-rounded-full tw-flex-shrink-0" />;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== drop.created_at) {
    t15 = getTimeAgoShort(drop.created_at);
    $[32] = drop.created_at;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t15) {
    t16 = <p className="tw-text-xs tw-mb-0 tw-whitespace-nowrap tw-font-normal tw-leading-none tw-text-iron-500">{t15}</p>;
    $[34] = t15;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t10 || $[37] !== t13 || $[38] !== t16) {
    t17 = <div className="tw-flex tw-items-center tw-gap-x-2">{t10}{t13}{t14}{t16}</div>;
    $[36] = t10;
    $[37] = t13;
    $[38] = t16;
    $[39] = t17;
  } else {
    t17 = $[39];
  }
  let t18;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="tw-flex tw-items-center tw-rounded-md tw-font-medium tw-whitespace-nowrap tw-px-2 tw-py-0.5 tw-bg-iron-600/10 tw-text-iron-500 tw-border tw-border-solid tw-border-iron-500/25 tw-w-fit"><span className="tw-text-xs">Participant</span></div>;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== t17) {
    t19 = <div className="tw-flex tw-flex-col tw-gap-y-2">{t17}{t18}</div>;
    $[41] = t17;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== drop.wave || $[44] !== handleNavigation || $[45] !== showWaveInfo) {
    t20 = showWaveInfo && (() => {
      const waveMeta = (drop.wave as unknown as {
        chat?: {
          scope?: {
            group?: {
              is_direct_message?: boolean | undefined;
            } | undefined;
          } | undefined;
        } | undefined;
      })?.chat;
      const isDirectMessage = waveMeta?.scope?.group?.is_direct_message ?? false;
      const waveHref = getWaveRoute({
        waveId: drop.wave.id,
        isDirectMessage,
        isApp: false
      });
      return <Link href={waveHref} onClick={e_1 => handleNavigation(e_1, waveHref)} className="tw-text-[11px] tw-leading-0 tw-text-iron-500 hover:tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out tw-no-underline">{drop.wave.name}</Link>;
    })();
    $[43] = drop.wave;
    $[44] = handleNavigation;
    $[45] = showWaveInfo;
    $[46] = t20;
  } else {
    t20 = $[46];
  }
  let t21;
  if ($[47] !== activePartIndex || $[48] !== drop || $[49] !== handleLongPress || $[50] !== onDropContentClick || $[51] !== onQuoteClick) {
    t21 = <WaveDropContent drop={drop} activePartIndex={activePartIndex} setActivePartIndex={setActivePartIndex} onLongPress={handleLongPress} onDropContentClick={onDropContentClick} onQuoteClick={onQuoteClick} setLongPressTriggered={setLongPressTriggered} isCompetitionDrop={true} />;
    $[47] = activePartIndex;
    $[48] = drop;
    $[49] = handleLongPress;
    $[50] = onDropContentClick;
    $[51] = onQuoteClick;
    $[52] = t21;
  } else {
    t21 = $[52];
  }
  let t22;
  if ($[53] !== t19 || $[54] !== t20 || $[55] !== t21) {
    t22 = <div className="tw-flex tw-flex-col tw-w-full tw-gap-y-2">{t19}{t20}{t21}</div>;
    $[53] = t19;
    $[54] = t20;
    $[55] = t21;
    $[56] = t22;
  } else {
    t22 = $[56];
  }
  let t23;
  if ($[57] !== t22 || $[58] !== t9) {
    t23 = <div className="tw-flex tw-gap-x-3 tw-w-full tw-text-left tw-bg-transparent tw-border-0">{t9}{t22}</div>;
    $[57] = t22;
    $[58] = t9;
    $[59] = t23;
  } else {
    t23 = $[59];
  }
  let t24;
  if ($[60] !== drop.metadata) {
    t24 = drop.metadata.length > 0 && <div className="tw-flex tw-w-full tw-items-center tw-gap-x-2 tw-gap-y-1 tw-flex-wrap"><WaveDropMetadata metadata={drop.metadata} /></div>;
    $[60] = drop.metadata;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[62] !== drop) {
    t25 = <div className="tw-flex tw-w-full tw-items-center tw-gap-x-2 tw-gap-y-1 tw-flex-wrap"><WaveDropReactions drop={drop} /></div>;
    $[62] = drop;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== drop || $[65] !== handleOnQuote || $[66] !== handleOnReply || $[67] !== isSlideUp || $[68] !== longPressTriggered || $[69] !== showReplyAndQuote) {
    t26 = <WaveDropMobileMenu drop={drop} isOpen={isSlideUp} longPressTriggered={longPressTriggered} showReplyAndQuote={showReplyAndQuote} setOpen={setIsSlideUp} onReply={handleOnReply} onQuote={handleOnQuote} onAddReaction={handleOnAddReaction} />;
    $[64] = drop;
    $[65] = handleOnQuote;
    $[66] = handleOnReply;
    $[67] = isSlideUp;
    $[68] = longPressTriggered;
    $[69] = showReplyAndQuote;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  let t27;
  if ($[71] !== t23 || $[72] !== t24 || $[73] !== t25 || $[74] !== t26 || $[75] !== t7 || $[76] !== t8) {
    t27 = <div className={t7}>{t8}{t23}{t24}{t25}{t26}</div>;
    $[71] = t23;
    $[72] = t24;
    $[73] = t25;
    $[74] = t26;
    $[75] = t7;
    $[76] = t8;
    $[77] = t27;
  } else {
    t27 = $[77];
  }
  let t28;
  if ($[78] !== t27 || $[79] !== t6) {
    t28 = <div className={t6}>{t27}</div>;
    $[78] = t27;
    $[79] = t6;
    $[80] = t28;
  } else {
    t28 = $[80];
  }
  return t28;
}